export const ERROR_CODES = {
  // Script loading
  SCRIPT_LOAD_FAILED: "SCRIPT_LOAD_FAILED",
  SDK_NOT_READY: "SDK_NOT_READY",

  // IMP
  IMP_REQUEST_FAILED: "IMP_REQUEST_FAILED",
  IMP_PAYMENT_FAILED: "F500",

  // PortOne
  PORTONE_UNKNOWN_ERROR: "UnknownError",
  PORTONE_REQUEST_FAILED: "PORTONE_REQUEST_FAILED",
  PORTONE_FAILURE_TYPE_PG: "FAILURE_TYPE_PG",

  // Axios
  ERR_NETWORK: "ERR_NETWORK",

  // Trainer Booking
  LEARNER_NOT_AVAILABLE: "LEARNER_NOT_AVAILABLE",
};